import {
  createResource,
  createSender,
  createUpdater,
  r,
} from '@/plugins/resource'
import { prefixAPI, queryPostfix } from '@/plugins/resource/api'

const MODEL = 'admin'
const DOCTORS_MODEL = MODEL + '/doctors'
const USERS_MODEL = MODEL + '/users'
const USER_ANALYTICS_MODEL = USERS_MODEL + '/analitics'
const USER_ANALYTICS_REGISTRATION_MODEL = USER_ANALYTICS_MODEL + '/registration'

export const SERVICE_MODERATION_REASONS_LIST_URL = prefixAPI(
  MODEL + '/reason/list/'
)

export const adminApi = {
  users: {
    analytics: {
      registration: {
        export: createResource(
          prefixAPI(queryPostfix(USER_ANALYTICS_REGISTRATION_MODEL + '/export/', ['filters']))
        ),
        filterList: r('/filter-list/', USER_ANALYTICS_REGISTRATION_MODEL),
        list: r(
          queryPostfix('/list/', ['filters']),
          USER_ANALYTICS_REGISTRATION_MODEL
        ),
      },
    },
    detail: r('/detail{/id}/', USERS_MODEL),
    filterList: r('/filter-list/', USERS_MODEL),
    list: r(queryPostfix('/list/', ['filters']), USERS_MODEL),
    update: r('/update{/id}/', USERS_MODEL, createUpdater),
  },
  doctors: {
    acton: {
      activate: r('/action/activate/', DOCTORS_MODEL, createSender),
      blocked: r('/action/blocked/', DOCTORS_MODEL, createSender),
    },
    detail: r('/detail{/id}/', DOCTORS_MODEL),
    filterList: r('/filter-list/', DOCTORS_MODEL),
    list: r(queryPostfix('/list/', ['filters']), DOCTORS_MODEL),
  },
}
